import React from "react";
import styled from "styled-components";
import successIcon from "../../../assets/svg/success.svg";
import errorIcon from "../../../assets/svg/error.svg";
import emailIcon from "../../../assets/svg/email.svg";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  margin-top: 4rem;
`
  ;

const messageResponse = (props) => {
  let imgIcon = "";
  let colorTitle = "";
  switch (props.type) {
    case "success":
      imgIcon = successIcon;
      colorTitle = "#17d66f";
      break;
    case "error":
      imgIcon = errorIcon;
      colorTitle = "#d6174a";
      break;
    case "email":
      imgIcon = emailIcon;
      colorTitle = "#3f66b3";
      break;
    default:
      break;
  }

  return (
    <Container>
      <Wrapper >
        <img src={imgIcon} alt="" style={{ width: "8.5rem" }} />
        <h4 style={{ color: colorTitle, margin: "1rem", fontSize: "2.8rem" }}>
          {props.title}
        </h4>
        <p style={{textAlign: "center", fontSize: "1.6rem", marginBottom: "2rem"}}>{props.children}</p>
      </Wrapper>
    </Container>
  );
};

export default messageResponse;
